import Ajax from './ajax';
import Log from './log';
import Cookie from 'js-cookie';
import ErrorService from './error-service';
import Mixpanel from './mixpanel';

// Mixpanel event whitelist
const MIXPANEL_WHITELIST = [
  'suggested_invites:',
  'suggested_follow:',
  'tune-up:',
  'screenshot:',
  'app_invite:',
  'invite:',
  'cashback_ig_story_share:',
  'invites_nudge:',
  'rec:ig_story_share',
  'external:',
  'dashboard:',
  'notification_menu:',
  'notification:',
  'signup_modal:',
  'tiktok_challenge:',
  'discover:category_click',
  'discover:page_end_reached',
  'global_search:selected',
  'global_search:searched',
  'profile:view',
  'group:view',
  'onboarding:',
];

// Check if an event should be tracked in Mixpanel based on whitelist
function shouldTrackInMixpanel(eventType) {
  if (!eventType) return false;

  return MIXPANEL_WHITELIST.some(prefix => {
    if (prefix.endsWith(':')) {
      return eventType.startsWith(prefix);
    } else {
      return eventType === prefix;
    }
  });
}

let blockCrawlerCache;

function blockCrawler() {
  if (blockCrawlerCache !== undefined) return blockCrawlerCache;

  if (
    typeof window === 'undefined' ||
    typeof window.navigator === 'undefined' ||
    typeof window.navigator.userAgent === 'undefined'
  ) {
    blockCrawlerCache = false;
  } else {
    let ua = window.navigator.userAgent.toLowerCase();
    blockCrawlerCache = ua.includes('semrush') || ua.includes('googlebot');
  }

  return blockCrawlerCache;
}

function detectScreenSize() {
  if (typeof window === 'undefined') return {};

  return {
    screen_width: window.innerWidth,
    screen_height: window.innerHeight,
  };
}

function track(event_type, data) {
  if (blockCrawler()) {
    return;
  }

  const eventData = {
    event_type,
    data,
    benable_user: Cookie.get('benable-user') || false,
    ...detectScreenSize(),
  };

  let resp = Ajax.post({
    withErrorHandling: false,
    url: '/events',
    data: eventData,
  }).catch((err) => {
    let msg = `[ERROR] Event: ${event_type} | ${JSON.stringify(data)} | status: ${err.status}`;

    ErrorService.capture(msg);
    Log.info(msg, true);
  });

  if (typeof(window) === 'object' && window.APP_ENV === 'production' && shouldTrackInMixpanel(event_type)) {
    Mixpanel.track(event_type, {
      ...data,
      source: Ajax.isChromeExtension() ? 'chrome-extension' : 'web',
      benable_user: Cookie.get('benable-user') || false
    });
  }

  return resp;
}

export default {
  track: track,
};
